type Config = {
	website_url: { paris: string; sud: string; centre: string; ecg: string; };
	rh_url: string;
	api_endpoint: string;
}

type Data = { config: Config; hostnames: (string | RegExp)[]; }

const allConfigs: Data[] = [
	{
		config: {
			website_url: {
				paris: 'https://dev-jts-www-japan-expo-paris-com.staging.stonecode.io',
				sud: 'https://dev-jts-www-japan-expo-sud-com.staging.stonecode.io',
				centre: 'https://dev-jts-www-japan-expo-centre-com.staging.stonecode.io',
				ecg: 'https://dev-jts-www-ecg-cosplay-com.staging.stonecode.io',
			},
			rh_url: 'https://dev-recrutement-japan-expo-com.staging.stonecode.io',
			api_endpoint: 'https://dev-jts-api.staging.stonecode.io',
		},
		hostnames: [/.*dev-myaccount-japan-expo-com\..+/i, 'localhost'],
	},
	{
		config: {
			website_url: {
				paris: 'https://demo-jts-www-japan-expo-paris-com.staging.stonecode.io',
				sud: 'https://demo-jts-www-japan-expo-sud-com.staging.stonecode.io',
				centre: 'https://demo-jts-www-japan-expo-centre-com.staging.stonecode.io',
				ecg: 'https://demo-jts-www-ecg-cosplay-com.staging.stonecode.io',
			},
			rh_url: 'https://demo-recrutement-japan-expo-com.staging.stonecode.io',
			api_endpoint: 'https://demo-jts-api.staging.stonecode.io',
		},
		hostnames: [/.*demo-myaccount-japan-expo-com\..+/i],
	},
	{
		config: {
			website_url: {
				paris: 'https://preproduction-jts-www-japan-expo-paris-com.staging.stonecode.io',
				sud: 'https://preproduction-jts-www-japan-expo-sud-com.staging.stonecode.io',
				centre: 'https://preproduction-jts-www-japan-expo-centre-com.staging.stonecode.io',
				ecg: 'https://preproduction-jts-www-ecg-cosplay-com.staging.stonecode.io',
			},
			rh_url: 'https://preproduction-recrutement-japan-expo-com.staging.stonecode.io',
			api_endpoint: 'https://preproduction-jts-api.staging.stonecode.io',
		},
		hostnames: [/.*preproduction-myaccount-japan-expo-com\..+/i],
	},
	{
		config: {
			website_url: {
				paris: 'https://www.japan-expo-paris.com',
				sud: 'https://www.japan-expo-sud.com',
				centre: 'https://www.japan-expo-centre.com',
				ecg: 'https://www.ecg-cosplay.com',
			},
			rh_url: 'https://recrutement.japan-expo.com',
			api_endpoint: 'https://api.japan-expo.com',
		},
		hostnames: [/myaccount\.japan-expo\.com/],
	},
];

const getConfig = () => {
	const config = allConfigs.find(config => {
		return config.hostnames.find(hostname => {
			if (typeof hostname === 'string') {
				return hostname === location.hostname;
			}

			return hostname.test(location.hostname);
		});
	});

	if (!config) {
		throw `Config not found for hostname ${location.hostname}`;
	}

	return config.config;
};

export default getConfig();